// para modificar una modalidad de torneo
export const SET_LOADING = 'SET_LOADING'
export const SET_SHOWMSJ = 'SET_SHOWMSJ'
